/* tslint:disable */

type BrowserLogger =
  | typeof console.log
  | typeof console.debug
  | typeof console.error
  | typeof console.warn
  | typeof console.dir;

const allLoggers = [
  console.log,
  console.debug,
  console.error,
  console.warn,
  console.dir,
];

type LogLevel = 'NONE' | 'ERROR' | 'WARN' | 'INFO' | 'DEBUG';

const logLevels: { [k in LogLevel]: k } = {
  NONE: 'NONE',
  ERROR: 'ERROR',
  WARN: 'WARN',
  INFO: 'INFO',
  DEBUG: 'DEBUG',
};

/* const logStyles = {
  INFO: 'color: #B8E986;',
  
}


const styliseMessage = (style: string, message: any) => [`%c ${message}`, style]; */
const styliseMessage = (style: string, message: any) => [
  `%c ${message}`,
  style,
];

const logLevelLoggers: { [k in keyof typeof logLevels]: BrowserLogger[] } = {
  NONE: [],
  ERROR: [console.error],
  WARN: [console.error, console.warn],
  INFO: [console.warn, console.error, console.dir, console.log],
  DEBUG: allLoggers,
};
let config = {
  showTrace: false,
  colors: false,
  timestamps: false,
  level: 'INFO' as keyof typeof logLevels,
  timestampFormatter: (date: Date) =>
    `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}.${date.getMilliseconds()}`,
};

export const updateConfig = (conf: Partial<typeof config>) =>
  (config = { ...config, ...conf });

const makeLogFn =
  (fn: BrowserLogger) =>
  (...params: any[]) => {
    if (config.level === 'NONE') return;
    const allowedLoggers = logLevelLoggers[config.level];
    if (allowedLoggers.find((logger) => logger === fn)) {
      fn(
        ...[
          ...(config.timestamps
            ? [
                ...styliseMessage(
                  'font-weight: bold;',
                  config.timestampFormatter(new Date())
                ),
              ]
            : []),
          ...params,
          ...(config.showTrace ? ['STACK TRACE: ', console.trace()] : []),
        ]
      );
    }
  };

export const warn = makeLogFn(console.warn);
export const log = makeLogFn(console.log);
export const dir = makeLogFn(console.dir);
export const error = makeLogFn(console.error);
export const debug = makeLogFn(console.debug);

export const rcLogger = {
  log,
  warn,
  dir,
  error,
  debug,
  updateConfig,
};
